import { useAuth } from '../context/AuthContext.jsx';

export default function LoginScreen() {
  const { authError } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0C0C0E',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Manrope', system-ui, sans-serif",
    }}>
      <div style={{ width: 340, padding: 32 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src='/riester-logo.png' alt='RIESTER' style={{
            width: 160, marginBottom: 20, opacity: 0.9,
          }} />
          <img src='/favicon.png' alt='R' style={{ width: 52, height: 52, margin: '0 auto 14px', borderRadius: 14 }} />
          <h1 style={{
            fontSize: 22, fontWeight: 700, color: '#E8E6E1',
            margin: '0 0 4px', letterSpacing: '-0.02em',
          }}>Riester Fonts</h1>
          <p style={{
            fontSize: 12, color: 'rgba(232,230,225,0.35)', margin: 0,
          }}>Team font management</p>
        </div>

        {/* Error display */}
        {authError && (
          <div style={{
            padding: '10px 14px', marginBottom: 16,
            background: 'rgba(232,85,85,0.08)',
            border: '1px solid rgba(232,85,85,0.2)',
            borderRadius: 8,
            color: '#E85555', fontSize: 12,
          }}>{authError}</div>
        )}

        {/* Google Sign In */}
        <a
          href="/api/auth/google"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: 10, width: '100%', padding: 12,
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 8, color: '#E8E6E1',
            fontSize: 13, fontWeight: 600,
            textDecoration: 'none',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
            transition: 'background 0.15s, border-color 0.15s',
            cursor: 'pointer',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.18)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign in with Google
        </a>

        <p style={{
          textAlign: 'center', fontSize: 11,
          color: 'rgba(232,230,225,0.2)', marginTop: 24,
        }}>Access restricted to @riester.com accounts</p>
      </div>
    </div>
  );
}
